export const initialState = {
    loading: false,
    error: null,
    response: { message: null, error: null },
    units: [],
}